// Mounts the tf-frontend micro-frontend via qiankun's loadMicroApp. Deliberately
// not using registerMicroApps/start(): this is embedded behind one wildcard route
// (/react/*) inside an app with a large existing router.beforeEach guard chain, and
// start() would patch global history and re-evaluate every registered app's
// activeRule on every navigation. loadMicroApp maps 1:1 to the Vue view's
// mounted/beforeRouteUpdate/beforeDestroy instead.

const MICRO_APP_NAME = "react-talentfind"; // must equal webpack output.library.name in tf-frontend
const ENTRY = process.env.VUE_APP_REACT_ENTRY || "http://localhost:3000";

export async function mountTfFrontend({ container, store, router, initialPath }) {
  // Dynamic imports keep qiankun and the bridge out of the host's main bundle
  // entirely unless this route is actually visited.
  const [{ loadMicroApp }, { createHostBridge }] = await Promise.all([
    import("qiankun"),
    import("./hostBridge"),
  ]);

  const bridge = createHostBridge(store, router);

  const microApp = loadMicroApp(
    {
      name: MICRO_APP_NAME,
      entry: ENTRY,
      container,
      props: { hostBridge: bridge, initialPath },
    },
    {
      sandbox: { experimentalStyleIsolation: true },
      singular: false, // host content must not be torn down
    },
  );

  return {
    microApp,
    bridge,
    async destroy() {
      bridge.destroy();
      try {
        await microApp.unmount();
      } catch (err) {
        console.warn("[qiankun] tfFrontend unmount failed", err);
      }
    },
  };
}
